
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form19";
const form19State = namespace("Form19");

import Form19ProcessHeader from "@/components/process/Form19/components/Form19ProcessHeader.vue";
import Form19 from "@/components/process/Form19/components/pdf/Form19.vue"

import { form19StatusInfoType } from '@/types/Information/Form19';

@Component({
    components:{
        Form19ProcessHeader,
        Form19
    }
})
export default class PreviewForm19 extends Vue {

    @form19State.State
    public currentNoticeOfWithdrawalOfLawyerId: string;

    stepsCompleted = {} as form19StatusInfoType; 
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;         
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form19"}); 
    }
}
